module.exports = __webpack_public_path__ + "assets/8fbbac6babd7011d91547596f306e922.png";